import { getProducts } from "../requests/products"
import { getResorts } from "../requests/resorts"
import { getActivities } from "../requests/activities"
import { getDurations } from "../requests/durations"

const productsAndFieldsPageContent = [
  {
    "type": "title",
    "content": "Products & fields",
  },
  {
    "type": "subtitle",
    "content": "Use these endpoints to fetch all metadata required to create a purchase draft. Combine resort, activity, and duration filters when requesting products to obtain the matching product_id."
  },
  {
    "type": "subtitle",
    "content": "All responses are localized according to the language header when provided."
  },
  {
    "type": "separator"
  },
  {
    ...getProducts,
    "anchor": "list-products",
  },
  {
    ...getResorts,
    "anchor": "resorts",
  },
  {
    ...getActivities,
    "anchor": "activities",
  },
  {
    ...getDurations,
    "anchor": "durations",
  },
]

export default productsAndFieldsPageContent
